export default __webpack_public_path__ + "static/media/A1.283499d1.mp3";